"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.saveImageBase64 = exports.saveImageUrl = void 0;
var permission_1 = require("./permission");
/**
 * 保存网络图片到相册
 * @param url 网络图片地址
 */
function saveImageUrl(url) {
    var _this = this;
    return new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
        var permission, dtask, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, (0, permission_1.checkPermission)('Album')];
                case 1:
                    permission = _a.sent();
                    if (!permission) {
                        reject(new Error('相册权限未授权'));
                        return [2 /*return*/];
                    }
                    dtask = window.plus.downloader.createDownload(url, {}, function (d, status) {
                        // 下载完成
                        if (status === 200) {
                            var fileName = d.filename || '';
                            // 保存至本地相册
                            window.plus.gallery.save(fileName, function () {
                                resolve();
                            }, function (e) {
                                reject(e);
                            });
                        }
                        else {
                            reject(new Error("".concat(status, ": \u4E0B\u8F7D\u4EFB\u52A1\u5931\u8D25")));
                        }
                    });
                    // 开始下载任务
                    dtask.start();
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    reject(error_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); });
}
exports.saveImageUrl = saveImageUrl;
/**
 * 保存base64图片到相册
 * @param base64Img base64图片地址
 */
function saveImageBase64(base64Img) {
    var _this = this;
    return new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
        var permission, bitmap_1, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, (0, permission_1.checkPermission)('Album')];
                case 1:
                    permission = _a.sent();
                    if (!permission) {
                        reject(new Error('相册权限未授权'));
                        return [2 /*return*/];
                    }
                    bitmap_1 = new window.plus.nativeObj.Bitmap();
                    // 从本地加载Bitmap图片
                    bitmap_1.loadBase64Data(base64Img, function () {
                        bitmap_1.save("_doc/himo_".concat((new Date()).getTime(), ".jpg"), {
                            overwrite: true,
                            quality: 10
                        }, function (i) {
                            // 保存至本地相册
                            window.plus.gallery.save(i.target, function () {
                                resolve();
                            }, function (e) {
                                reject(e);
                            });
                        }, function (e) {
                            reject(e);
                        });
                    }, function (e) {
                        reject(e);
                    });
                    return [3 /*break*/, 3];
                case 2:
                    error_2 = _a.sent();
                    reject(error_2);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); });
}
exports.saveImageBase64 = saveImageBase64;
//# sourceMappingURL=image.js.map